import React from 'react';
export function StickyHeader() {
  return <div className="sticky top-0 z-40 flex min-h-[36px] w-full items-center justify-center bg-aura px-4 py-2 text-center" data-id="element-249" data-mp="2zat6uoerv308">
      <p className="text-[11px] font-normal leading-snug text-white sm:text-xs" data-id="element-250" data-mp="1ir7vcknq3lv6">
        <span className="sm:hidden" data-id="element-251" data-mp="1ip56i3yb3ys1">🌎 Disponible en toda Latinoamérica · Acceso inmediato</span>
        <span className="hidden sm:inline" data-id="element-252" data-mp="1dq20ohai5oj0">
          🌎 Disponible para toda Latinoamérica · Acceso digital inmediato · Pago único · La página
          convierte el precio a tu moneda local automáticamente
        </span>
      </p>
    </div>;
}